import { useState, useCallback, memo } from "react";
import { PropTypes } from "prop-types";

import { maskValue } from "./utils/MaskedFn";
import { Iconify } from "@repo/design-system/components/ui";
import { PasswordVerificationModal } from "./passwordVerificationModal/PasswordVerificationModal";

const MaskedValueComponent = ({
    value,
    fallback = "N/A",
    maskedType = "",
    iconSize = 16,
    targetId,
    isIconVisible = true,
    isPasswordRequired = true,
}) => {
    const [show, setShow] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleIconClick = useCallback(() => {
        if (show) {
            setShow(false);
        } else if (isPasswordRequired) {
            setIsModalOpen(true);
        } else {
            setShow(true);
        }
    }, [show, isPasswordRequired]);

    const handleCloseModal = useCallback(() => {
        setIsModalOpen(false);
    }, []);

    const handleSuccessVerification = useCallback(() => {
        setShow(true);
        setIsModalOpen(false);
    }, []);

    const displayValue = value ? show ? value : maskValue(value, maskedType) : fallback;

    return (
        <div className="d-flex align-items-center gap-2">
            <span>{displayValue}</span>

            {value && isIconVisible && (
                <Iconify
                    icon={show ? "lucide:eye" : "lucide:eye-off"}
                    onClick={handleIconClick}
                    className="cursor-pointer"
                    width={iconSize}
                    ttLabel={show ? "Hide" : "Show"}
                    targetId={targetId}
                />
            )}

            {isPasswordRequired && (
                <PasswordVerificationModal
                    isOpen={isModalOpen}
                    onClose={handleCloseModal}
                    onSuccess={handleSuccessVerification}
                />
            )}
        </div>
    );
};

MaskedValueComponent.propTypes = {
    value: PropTypes.string.isRequired,
    fallback: PropTypes.string,
    maskFn: PropTypes.func,
    iconSize: PropTypes.number,
    targetId: PropTypes.string,
    isIconVisible: PropTypes.bool,
    isPasswordRequired: PropTypes.bool,
};

export const MaskedValue = memo(MaskedValueComponent);